var datePicker = document.querySelector('#option-5664797727129600');
if (datePicker) {
  datePicker.addEventListener('change', function(e) {
    var dateParts = this.value.split("-");
    var selectedDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]); // Months are 0-indexed

    var christmasDay = new Date(selectedDate.getFullYear(), 11, 25); // December is month 11
    var thanksgivingDay = new Date(selectedDate.getFullYear(), 10, 1);
    var firstThursday = thanksgivingDay.getDay() === 4 ? 1 : (4 - thanksgivingDay.getDay() + 7) % 7 + 1;
    thanksgivingDay.setDate(firstThursday + 21);

    const feeButton = document.querySelector('.ef__product-option-input[data-value-title="Holiday Fee"]');
    const nofeeButton = document.querySelector('.ef__product-option-input[data-value-title="No Fee"]');
    var addonsPrice = document.querySelector('.ef__options-addon-total-amount');
    var addonsPriceValue = addonsPrice.innerHTML.substring(1);

    if (selectedDate.toDateString() === thanksgivingDay.toDateString() || selectedDate.toDateString() === christmasDay.toDateString()) {
      nofeeButton.checked = false;
      feeButton.checked = true;
      addonsPrice.innerHTML = '$' + (parseFloat(addonsPriceValue) + 100);
    } else {
      nofeeButton.checked = true;
      feeButton.checked = false;
      addonsPrice.innerHTML = '$' + (parseFloat(addonsPriceValue) - 100);
    }


    feeButton.dispatchEvent(new Event("change"));
    nofeeButton.dispatchEvent(new Event("change"));
  });
}
